// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { documentsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDocuments";
import File from "@insite/mobius/Icons/File";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
        &:before {
            content: "${translate("Documents")}:";
            font-size: 18px;
            font-weight: bold;
            width: 100%;
            display: block;
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 8px;
        }
        & > div:first-child {
            margin-top: 20px;
        }
    `,
};

documentsStyles.documentIcon = {
    src: File,
    size: 16,
    color: "common.ui4",
    css: css`
        margin-right: 4px;
    `,
};

documentsStyles.documentNameText = {
    size: 16,
    weight: "normal",
    lineHeight: "16px",
    css: css`
        display: inline-block;
        vertical-align: super;
    `,
};

documentsStyles.documentLink = {
    typographyProps: {
        css: css`
            display: flex;
            align-items: flex-end;
        `,
    },
};
